import React from 'react';
import { HiOutlineCursorClick, HiOutlineCalendar, HiOutlineSparkles } from 'react-icons/hi';

const HowItWorks = () => {
    const steps = [
        {
            id: "01",
            title: "Select Service",
            description: "Choose the cleaning service you need from our comprehensive available options.",
            icon: <HiOutlineCursorClick size={36} />
        },
        {
            id: "02",
            title: "Set Schedule",
            description: "Select a convenient date and time that fits perfectly into your busy lifestyle.",
            icon: <HiOutlineCalendar size={36} />
        },
        {
            id: "03",
            title: "Relax & Enjoy",
            description: "Our experts will clean thoroughly, leaving your space fresh and absolutely spotless.",
            icon: <HiOutlineSparkles size={36} />
        }
    ];

    return (
        <section className="section-padding bg-white relative overflow-hidden">
            <div className="container-custom">
                <div className="text-center max-w-3xl mx-auto mb-20 space-y-4">
                    <p className="text-primary font-bold uppercase tracking-widest text-sm">Working Process</p>
                    <h2 className="text-4xl md:text-5xl font-heading font-black">How It Works</h2>
                    <p className="text-muted-foreground text-lg">
                        Our simple three-step process makes it effortless for you to maintain a premium, clean home.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
                    {/* Decorative Line (Desktop) */}
                    <div className="hidden md:block absolute top-[25%] left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent -z-10"></div>
                    
                    {steps.map((step, index) => (
                        <div key={index} className="text-center space-y-8 relative group">
                            <div className="relative inline-block">
                                <div className="w-24 h-24 rounded-3xl bg-secondary flex items-center justify-center text-primary border-2 border-primary/5 shadow-xl group-hover:bg-primary group-hover:text-white group-hover:-translate-y-2 transition-all duration-500">
                                    {step.icon}
                                </div>
                                <div className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-accent text-accent-foreground font-black flex items-center justify-center text-sm shadow-lg">
                                    {step.id}
                                </div>
                            </div>
                            
                            <div className="space-y-4">
                                <h4 className="text-2xl font-bold">{step.title}</h4>
                                <p className="text-muted-foreground text-sm leading-relaxed px-4">
                                    {step.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;

